<template>
  <div class="perturbedgene">
    <a-row :gutter="[12, 24]">
      <a-col
        :xs="{ span: 0 }"
        :sm="{ span: 0 }"
        :md="{ span: 0 }"
        :xl="{ span: 6 }"
        :lg="{ span: 6 }"
      >
        <a-affix :offset-top="100">
          <a-card size="small" title="Table of contents">
            <a
              @click="changeHash('#basic')"
              type="primary"
              style="margin-top: 20px; font-size: 17px"
              >1. Gene information
            </a>
            <br />
            <a
              @click="changeHash('#score')"
              style="margin-top: 20px; font-size: 17px"
              type="primary"
              >2. Perturbation score
            </a>
            <br v-if="this.isPC" />
            <a
              @click="changeHash('#regulator')"
              style="margin-top: 20px; font-size: 17px; color: red"
              type="primary"
              v-if="this.isPC"
              >3. Perturbation cluster
            </a>
            <br />
            <a
              @click="changeHash('#tcga')"
              style="margin-top: 20px; font-size: 17px"
              type="primary"
            >
              <span v-if="this.isPC">4</span><span v-else>3</span>. Gene
              disorders of pan-cancers
            </a>
            <br />
            <a
              @click="changeHash('#de')"
              style="margin-top: 20px; font-size: 17px"
              type="primary"
            >
              <span v-if="this.isPC">5</span>
              <span v-else>4</span>. Expression profile changes
            </a>

            <br />
            <a
              @click="changeHash('#gsea')"
              style="margin-top: 20px; font-size: 17px"
              type="primary"
            >
              <span v-if="this.isPC">6</span>
              <span v-else>5</span>. GSEA Analysis</a
            >
            <br />
            <a
              @click="changeHash('#customeplot')"
              style="margin-top: 20px; font-size: 17px"
              type="primary"
            >
              <span v-if="this.isPC">7</span>
              <span v-else>6</span>. Gene expression visualization</a
            >
            <br />
            <a
              @click="changeHash('#pathway')"
              style="margin-top: 20px; font-size: 17px"
              type="primary"
            >
              <span v-if="this.isPC">8</span>
              <span v-else>7</span>. Cancer cell line encyclopedia (CCLE)
            </a>
            <br />
            <a
              @click="changeHash('#GTEx')"
              style="margin-top: 20px; font-size: 17px"
              type="primary"
            >
              <span v-if="this.isPC">9</span>
              <span v-else>8</span>. The Genotype-Tissue Expression (GTEx)
            </a>
            <br />
            <a
              @click="changeHash('#sgRNAseq')"
              style="margin-top: 20px; font-size: 17px"
              type="primary"
            >
              <span v-if="this.isPC">10</span>
              <span v-else>9</span>. sgRNA sequence
            </a>
          </a-card>
        </a-affix>
      </a-col>
      <a-col
        :sm="{ span: 24 }"
        :md="{ span: 24 }"
        :xl="{ span: 18 }"
        :gutter="[16, 24]"
      >
        <div style="text-align: center">
          <h1 style="font-size: 20px; color: red">
            <i style="font-weight: bolder">
              {{ this.$route.query.datasetId }}</i
            >
          </h1>
        </div>
        <a-row>
          <a-col
            :sm="{ span: 24 }"
            :md="{ span: 24 }"
            :xl="{ span: 24 }"
            id="basic"
          >
            <!-- <h1 class="h1">Result of perturbed-gene</h1>
            <a-alert
              message="This page presents the results of the gene difference analysis and functional enrichment analysis of the perturbed genes."
              type="success"
              :style="{ borderRadius: '5px' }"
            /> -->
            <a-card
              size="small"
              style="
                margin-top: 10px;
                border-radius: 5px;
                border-color: #c9c9c9;
              "
              hoverable
              :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
            >
              <a
                slot="title"
                class="guider"
                style="font-size: 20px; color: black"
              >
                Gene Information
                <!-- of {{ this.$route.query.gene }} -->
              </a>
              <a-descriptions bordered size="small">
                <a-descriptions-item label="Gene name">
                  {{ this.gene }}
                </a-descriptions-item>
                <a-descriptions-item label="Ensembl ID">
                  <a
                    :href="
                      'https://www.genecards.org/cgi-bin/carddisp.pl?gene=' +
                      this.ensgId
                    "
                    target="_blank"
                    style="color: blue"
                  >
                    {{ this.ensgId }}
                  </a>
                </a-descriptions-item>
                <a-descriptions-item label="Gene type">
                  {{ this.genetype }}
                </a-descriptions-item>
                <a-descriptions-item label="Alias">
                  {{ this.alias }}
                </a-descriptions-item>
                <a-descriptions-item label="NCBI gene">
                  {{ this.geneId }}
                </a-descriptions-item>
                <a-descriptions-item label="Functional annotation">
                  <!-- 这个地方要进行判断 -->
                  <div style="text-align: center" v-if="this.genetag != null">
                    <div
                      v-for="(index, element) in this.genetag.split(',')"
                      :key="index"
                      :value="element"
                    >
                      <a-tag
                        v-if="index == 'RBP'"
                        color="pink"
                        style="margin-bottom: 2px"
                      >
                        {{ index }}
                      </a-tag>
                      <a-tag
                        v-if="index == 'TF'"
                        color="red"
                        style="margin-bottom: 2px"
                      >
                        {{ index }}
                      </a-tag>
                      <a-tag
                        v-if="index == 'Metabolism'"
                        color="orange"
                        style="margin-bottom: 2px"
                      >
                        {{ index }}
                      </a-tag>
                      <a-tag
                        v-if="index == 'Essential'"
                        color="green"
                        style="margin-bottom: 2px"
                      >
                        Essential gene
                      </a-tag>
                      <!-- <a-tag
                        v-if="index == 'E3'"
                        color="cyan"
                        style="margin-bottom: 2px"
                      >
                        {{ index }}
                      </a-tag> -->
                    </div>
                  </div>
                  <!-- <a-tag color="red">{{ this.genetag }}</a-tag> -->
                </a-descriptions-item>
                <!-- <a-descriptions-item label="Full name">
                  {{ this.fullname }}
                </a-descriptions-item>
                <a-descriptions-item label="UniProtKB">
                  {{ this.uniprot }}
                </a-descriptions-item>
                <a-descriptions-item label="Localization">
                  {{ this.localization }}
                </a-descriptions-item> -->

                <a-descriptions-item label="Description">
                  <div style="text-align: justify">
                    {{ this.summary }}
                  </div>
                </a-descriptions-item>
              </a-descriptions>
            </a-card>
          </a-col>
          <a-col
            :sm="{ span: 24 }"
            :md="{ span: 24 }"
            :xl="{ span: 24 }"
            style="margin-top: 10px"
            id="score"
          >
            <a-card
              size="small"
              style="
                margin-top: 10px;
                border-radius: 5px;
                border-color: #c9c9c9;
              "
              hoverable
              :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
            >
              <a
                slot="title"
                class="guider"
                style="margin-top: 10px; color: black"
              >
                Perturbation Score</a
              >
              <a-row>
                <a-col :span="24">
                  <a-popover
                    v-model="visibleScore"
                    trigger="hover"
                    placement="rightTop"
                  >
                    <div slot="title">Help</div>
                    <div slot="content" style="width: 600px">
                      <h3>
                        Density plot for perturbation cell identification and
                        scoring.
                      </h3>
                      It is assuming each target gene class is a mixture of two
                      Gaussian distributions one representing the perturbed(KO,
                      CRISPRi and CRISPRa etc.) and the other the non-perturbed
                      (NP) cells. So we further assume that the distribution of
                      the NP cells is identical to that of cells expressing
                      non-targeting gRNAs (NT) and we try to estimate the
                      distribution of perturbed cells using the mixscape
                      package. Mixscape calculate the posterior probability that
                      a cell belongs to the perturbed distribution and classify
                      cells with a probability
                      <span style="font-weight: bolder; color: red"
                        >higher than 0.5 as a real perturbed cell</span
                      >.
                    </div>
                    <a-button type="danger" size="small">
                      <a-icon type="question-circle" /><a-icon
                        v-if="!this.visibleScore"
                        type="caret-down" />
                      <a-icon v-if="this.visibleScore" type="caret-up"
                    /></a-button>
                  </a-popover>
                </a-col>
              </a-row>

              <a-row :gutter="[16, 24]">
                <a-col :sm="{ span: 24 }" :md="{ span: 24 }" :xl="{ span: 12 }">
                  <!-- <object :data="this.scorePDF" width="100%" height="500">
                 
                  </object> -->
                  <div
                    style="
                      margin-top: 20px;
                      margin-left: 20%;
                      text-align: center;
                    "
                  >
                    <div
                      style="color: black; font-weight: bolder; font-size: 17px"
                    >
                      Perturbation Rate : {{ this.PR }}
                    </div>
                    <img
                      alt="example"
                      height="80%"
                      width="80%"
                      :src="this.svgSrc"
                    />
                  </div>
                </a-col>
                <a-col :sm="{ span: 24 }" :md="{ span: 24 }" :xl="{ span: 12 }">
                  <tableScore />
                </a-col>
              </a-row>
            </a-card>
          </a-col>
          <a-col
            :sm="{ span: 24 }"
            :md="{ span: 24 }"
            :xl="{ span: 24 }"
            style="margin-top: 10px"
            id="regulator"
            v-if="this.isPC"
          >
            <a-card
              style="
                margin-top: 10px;
                border-radius: 5px;
                border-color: #c9c9c9;
              "
              hoverable
              :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
              size="small"
            >
              <a
                slot="title"
                class="guider"
                style="color: black"
                :href="this.pcLinks"
                target="_blank"
              >
                Perturbation Cluster
                <a-icon type="paper-clip" style="color: blue" />
              </a>

              <a-card style="width: 100%">
                <object
                  :data="this.pcplot"
                  width="100%"
                  height="450px"
                ></object>
              </a-card>
            </a-card>
          </a-col>
          <a-col
            :sm="{ span: 24 }"
            :md="{ span: 24 }"
            :xl="{ span: 24 }"
            style="margin-top: 10px"
            id="tcga"
          >
            <a-card
              size="small"
              style="
                margin-top: 10px;
                border-radius: 5px;
                border-color: #c9c9c9;
              "
              hoverable
              :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
            >
              <a class="guider" slot="title" style="color: black">
                Cancer Associations
                <!-- Role of {{ this.$route.query.gene }} gene in cancers -->
              </a>
              <a-tabs default-active-key="1">
                <a-tab-pane key="1">
                  <span slot="tab">
                    <a-icon type="box-plot" />
                    <a-badge
                      :count="this.diffcancer"
                      show-zero
                      :offset="[10, 0]"
                    >
                      Differential expression analysis
                    </a-badge>
                  </span>
                  <div class="gseaHallmark">
                    <a-row>
                      <a-col :span="24">
                        <a-spin :spinning="tcgaLoading" :indicator="indicator">
                          <vxe-toolbar>
                            <template #buttons>
                              <vxe-input
                                v-model="filterName_detable"
                                type="search"
                                placeholder="Input a key word"
                                @keyup="searchEvent_detable"
                              ></vxe-input>
                              <vxe-button @click="exportDataEvent"
                                ><a-icon type="cloud-download" />
                                Download</vxe-button
                              >
                            </template>
                          </vxe-toolbar>
                          <vxe-table
                            border
                            show-overflow
                            row-id="id"
                            size="small"
                            ref="xTable"
                            :data="tableData_detable"
                            class="my-sort"
                            align="center"
                            header-align="center"
                            :row-style="rowStyle"
                            :column-config="{ isHover: true }"
                            :row-config="{ isCurrent: true, isHover: true }"
                            :sort-config="{
                              showIcon: false,
                              trigger: all,
                            }"
                            @header-cell-click="headerCellClickEvent"
                          >
                            <vxe-column
                              field="cancer"
                              title="Cancer"
                              type="html"
                            >
                            </vxe-column>
                            <vxe-column
                              field="statistic"
                              title="Statistic"
                              type="html"
                            >
                              <template #default="{ row }">
                                {{
                                  Number.parseFloat(row.statistic).toPrecision(
                                    3
                                  )
                                }}
                              </template></vxe-column
                            >
                            <vxe-column field="log2fc" title="Log2FC" sortable>
                              <template #default="{ row }">
                                {{
                                  Number.parseFloat(row.log2fc).toPrecision(3)
                                }}
                              </template>

                              <template #header="{ column }">
                                <span>{{ column.title }}</span>
                                <span
                                  class="custom-sort"
                                  :class="{ 'is-order': column.order }"
                                >
                                  <i
                                    :class="[
                                      column.order
                                        ? `vxe-icon-sort-numeric-${column.order}`
                                        : 'vxe-icon-sort',
                                    ]"
                                  ></i>
                                </span>
                              </template>
                            </vxe-column>
                            <vxe-column field="pvalue" title="P-value" sortable>
                              <template #default="{ row }">
                                {{
                                  Number.parseFloat(row.pvalue).toPrecision(3)
                                }}
                              </template>
                              <template #header="{ column }">
                                <span>{{ column.title }}</span>
                                <span
                                  class="custom-sort"
                                  :class="{ 'is-order': column.order }"
                                >
                                  <i
                                    :class="[
                                      column.order
                                        ? `vxe-icon-sort-numeric-${column.order}`
                                        : 'vxe-icon-sort',
                                    ]"
                                  ></i>
                                </span>
                              </template>
                            </vxe-column>
                            <vxe-column field="Show" title="View" type="html">
                              <template #default="{ row }">
                                <div
                                  v-if="row.mk == 2"
                                  @click="showPDF(row.cancer, row.pvalue)"
                                >
                                  <a-button
                                    type="danger"
                                    shape="circle"
                                    icon="search"
                                  />
                                </div>
                                <div
                                  v-if="row.mk == 1"
                                  @click="showPDF(row.cancer, row.pvalue)"
                                >
                                  <a-button
                                    type="primary"
                                    shape="circle"
                                    icon="search"
                                  />
                                </div>
                                <div
                                  v-if="row.mk == 0"
                                  @click="showPDF(row.cancer, row.pvalue)"
                                >
                                  <a-button
                                    type="dashed"
                                    shape="circle"
                                    icon="search"
                                  />
                                </div>
                              </template>
                            </vxe-column>
                            <template #empty>
                              <span style="color: grey"> No more data! </span>
                            </template>
                          </vxe-table>

                          <vxe-pager
                            background
                            size="small"
                            :loading="loading_detable"
                            :current-page="tablePage_detable.currentPage"
                            :page-size="tablePage_detable.pageSize"
                            :total="tablePage_detable.totalResult"
                            :page-sizes="[10, 20]"
                            :layouts="[
                              'PrevPage',
                              'JumpNumber',
                              'NextPage',
                              // 'FullJump',
                              'Sizes',
                              'Total',
                            ]"
                            @page-change="handlePageChange_table"
                          >
                          </vxe-pager> </a-spin
                      ></a-col>
                    </a-row>
                    <a-modal
                      :visible="this.modal"
                      :maskClosable="false"
                      :keyboard="false"
                      :closable="true"
                      :width="800"
                      style="margin-top: 300px"
                      :footer="null"
                      @cancel="handleOk"
                    >
                      <div slot="title">TCGA based on sample types</div>
                      <div slot="cancelText">
                        <a-icon type="cloud-download" />
                      </div>
                      <TCGAboxplotModal
                        v-bind:ensgId="this.ensgId"
                        v-bind:selectCa="this.selectCancer"
                        v-bind:pvalue="this.pvalue"
                      />
                    </a-modal>
                  </div>
                </a-tab-pane>
                <a-tab-pane key="2">
                  <span slot="tab">
                    <a-icon type="fall" />
                    Survival plots
                  </span>
                  <survival v-bind:ensgId="this.ensgId" />
                </a-tab-pane>
                <a-tab-pane key="3">
                  <span slot="tab">
                    <a-icon type="sliders" />
                    Gene expression profile across all cancers
                  </span>
                  <tcgaAll />
                </a-tab-pane>
              </a-tabs>
            </a-card>
          </a-col>
          <a-col
            :sm="{ span: 24 }"
            :md="{ span: 24 }"
            :xl="{ span: 24 }"
            style="margin-top: 10px"
            id="ingibitor"
            v-if="this.showOncoPheno != 'No'"
          >
            <a-card
              style="
                margin-top: 10px;
                border-radius: 5px;
                border-color: #c9c9c9;
              "
              hoverable
              :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
              size="small"
            >
              <a slot="title" class="guider" style="color: black">
                Cancer-associated phenotypes
              </a>
              <oncoPheno v-if="!showOncoPheno.includes('No')" />
              <div v-else style="font-size: 18px; font-weight: bolder">
                <a-icon type="sound" theme="twoTone" two-tone-color="#FF0000" />
                <i style="margin-left: 8px"
                  >We do not assess the scoring of the gene here because its
                  cells have undergone a certain treatment.</i
                >
              </div>
            </a-card>
          </a-col>
          <a-col
            :sm="{ span: 24 }"
            :md="{ span: 24 }"
            :xl="{ span: 24 }"
            style="margin-top: 10px"
            id="de"
          >
            <a-card
              style="
                margin-top: 10px;
                border-radius: 5px;
                border-color: #c9c9c9;
              "
              hoverable
              :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
              size="small"
            >
              <a slot="title" class="guider" style="color: black">
                Perturbation-induced Differentially Expressed Gene
              </a>
              <a-row>
                <a-col :sm="{ span: 24 }" :md="{ span: 24 }" :xl="{ span: 10 }"
                  ><volcano />
                </a-col>
                <a-col :sm="{ span: 24 }" :md="{ span: 24 }" :xl="{ span: 14 }"
                  ><deTable
                /></a-col>
              </a-row>
            </a-card>
          </a-col>

          <a-col
            :sm="{ span: 24 }"
            :md="{ span: 24 }"
            :xl="{ span: 24 }"
            style="margin-top: 10px"
            id="gsea"
          >
            <a-card
              style="
                margin-top: 10px;
                border-radius: 5px;
                border-color: #c9c9c9;
              "
              hoverable
              :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
              size="small"
            >
              <a slot="title" class="guider" style="color: black">
                Gene Set Enrichment Analysis
              </a>
              <a-row>
                <gsea />
              </a-row>
            </a-card>
          </a-col>
          <a-col
            :sm="{ span: 24 }"
            :md="{ span: 24 }"
            :xl="{ span: 24 }"
            style="margin-top: 10px"
            id="customeplot"
          >
            <a-card
              size="small"
              style="
                margin-top: 10px;
                border-radius: 5px;
                border-color: #c9c9c9;
              "
              hoverable
              :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
            >
              <a class="guider" slot="title" style="color: black"
                >Visualization of Gene Expression Change Induced by Perturbed
                {{ this.$route.query.gene }}
                <a-tooltip title="Download .RDS file">
                  <a-button
                    @click="downloadRDS()"
                    style="
                      background-color: #e0e0e0;
                      color: #1890ff;
                      border-color: transparent;
                    "
                    ><a-icon type="cloud-download"
                  /></a-button>
                </a-tooltip>
              </a>
              <diyExp />
            </a-card>
          </a-col>
          <a-col
            :sm="{ span: 24 }"
            :md="{ span: 24 }"
            :xl="{ span: 24 }"
            style="margin-top: 10px"
            id="pathway"
          >
            <a-card
              size="small"
              style="
                margin-top: 10px;
                border-radius: 5px;
                border-color: #c9c9c9;
              "
              hoverable
              :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
            >
              <a slot="title" class="guider" style="color: black">
                Expression - CCLE
                <!-- <i style="color: grey; margin-left: 5px">
                  From Cancer cell line encyclopedia
                </i> -->
              </a>
              <ccle />
            </a-card>
          </a-col>
          <a-col
            :sm="{ span: 24 }"
            :md="{ span: 24 }"
            :xl="{ span: 24 }"
            style="margin-top: 10px"
            id="GTEx"
          >
            <a-card
              size="small"
              style="
                margin-top: 10px;
                border-radius: 5px;
                border-color: #c9c9c9;
              "
              hoverable
              :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
            >
              <a slot="title" class="guider" style="color: black">
                Expression - GTEx
                <!-- <i style="color: grey; margin-left: 5px"
                  >From The Genotype-Tissue Expression (GTEx) project</i
                > -->
              </a>
              <gtex v-bind:ensgId="this.ensgId" style="margin-top: 10px" />
            </a-card>
          </a-col>
          <a-col
            :sm="{ span: 24 }"
            :md="{ span: 24 }"
            :xl="{ span: 24 }"
            style="margin-top: 10px"
            id="sgRNAseq"
          >
            <a-card
              size="small"
              style="
                margin-top: 10px;
                border-radius: 5px;
                border-color: #c9c9c9;
              "
              hoverable
              :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
            >
              <a slot="title" class="guider" style="color: black">
                sgRNA Sequence
              </a>
              <sgRNA />
            </a-card>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import axios from "axios";
import XEUtils from "xe-utils";
import tableScore from "./subCom/scoreTable.vue";
import ccle from "./ccle.vue";
import oncoPheno from "./subCom/oncoPheno.vue";
import deTable from "./subCom/de_table.vue";
// import inhibitors from "./subCom/inhibitors.vue";
import gsea from "./subCom/gseaModule.vue";
import volcano from "./subCom/volcano.vue";
// import kegg from "./subCom/keggUpAndDown.vue";
// import wiki from "./subCom/wikiUpAndDown.vue";
// import reactome from "./subCom/reactomeUpAndDown.vue";
import diyExp from "./subCom/diy_expression.vue";
import tcgaAll from "./subCom/tcgaExpressionAll.vue";
// import tcgaPaired from "./subCom/tcgaExpressionPaired.vue";
import survival from "./subCom/survival.vue";
// import tcgaBoxplot from "./subCom/TCGAboxplot.vue";
import TCGAboxplotModal from "./subCom/TCGAboxplotModal.vue";
import sgRNA from "./primerPage.vue";
import gtex from "./gtexPage.vue";

// import pdf from "vue-pdf";
export default {
  components: {
    tableScore,
    deTable,
    ccle,
    oncoPheno,
    // inhibitors,
    gsea,
    volcano,
    // kegg,
    // wiki,
    // reactome,
    diyExp,
    tcgaAll,
    // tcgaPaired,
    survival,
    // tcgaBoxplot,
    TCGAboxplotModal,
    sgRNA,
    gtex,
  },
  created() {
    //Perturbation Rate
    axios
      .get(
        "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/publications_perturRate.php",
        {
          params: {
            gene: this.$route.query.gene,
            datasetId: this.$route.query.datasetId,
          },
        }
      )
      .then((response2) => {
        this.PR = String(parseFloat(response2.data).toFixed(2)) + "%";
      });
    //是否形成 perturbation cluster
    axios
      .get(
        "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/publications_pc.php",
        {
          params: {
            genename: this.$route.query.gene,
            datasetID: this.$route.query.datasetId,
          },
        }
      )
      .then((response2) => {
        const temp = response2.data.trim();
        if (temp.startsWith("PC")) {
          (this.isPC = true),
            (this.pcplot =
              "http://research.gzsys.org.cn/perturbdb/data/clusters/result_plot/" +
              temp +
              ".pdf");
          this.pcLinks =
            "http://research.gzsys.org.cn/perturbdb/#/pcDetails?pcID=" + temp;
          console.log(this.pcplot);
        }
      });

    axios
      .get(
        "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/perturbGene_basic.php",
        {
          params: {
            genename: this.$route.query.gene,
          },
        }
      )
      .then((response) => {
        //同一转一下.
        this.gene = response.data[0]["genename"];
        this.ensgId = response.data[0]["ensgId"];
        this.genetype = response.data[0]["genetype"];
        this.alias = response.data[0]["alias"]
          .replaceAll("|", ",")
          .substring(
            1,
            response.data[0]["alias"].replaceAll("|", ",").length - 1
          );
        this.geneId = response.data[0]["geneid"];
        this.genetag = response.data[0]["genetag"];
        this.summary = response.data[0]["summary"];
        this.fullname = response.data[0]["fullname"];
        this.localization = response.data[0]["localization"];
        this.uniprot = response.data[0]["uniprot"];
        axios
          .get(
            "http://research.gzsys.org.cn/perturbdb/API/TCGA/search_diffMessage.php",
            {
              params: {
                ensgId: this.ensgId,
              },
            }
          )
          .then((response) => {
            const convertedArray = [...response.data].sort(
              (a, b) => b.mk - a.mk
            );
            this.getdata_detable = convertedArray;
            this.findList_detable(this.getdata_detable);
            this.tcgaLoading = false;
          });
        //TCGA diffNum
        axios
          .get(
            "http://research.gzsys.org.cn/perturbdb/API/TCGA/search_diffNum.php",
            {
              params: {
                ensgId: this.ensgId,
              },
            }
          )
          .then((response2) => {
            this.diffcancer = response2.data;
          });
      });
    //oncoPheno
    // axios
    //   .get(
    //     "http://research.gzsys.org.cn/perturbdb/API/oncoPheno/check_genePheno.php",
    //     {
    //       params: {
    //         datasetID: this.$route.query.datasetId,
    //       },
    //     }
    //   )
    //   .then((response3) => {
    //     const tempM = response3.data.trim();
    //     if (tempM !== "No") {
    //       axios
    //         .get(
    //           "http://research.gzsys.org.cn/perturbdb/API/oncoPheno/search_genePheno.php",
    //           {
    //             params: {
    //               datasetID: this.$route.query.datasetId,
    //               gene: this.$route.query.gene,
    //             },
    //           }
    //         )
    //         .then((response) => {
    //           const convertedArray = response.data
    //             .filter((item) => item.medianT < item.medianC && item.p < 0.001)
    //             .sort((a, b) => a.p - b.p);
    //           if (convertedArray.length == 0) {
    //             this.showOncoPheno = "No";
    //           } else {
    //             this.showOncoPheno = "Yes";
    //           }
    //         });
    //     } else {
    //       this.showOncoPheno = "No";
    //     }
    //     console.log(this.showOncoPheno);
    //   });
  },
  data() {
    return {
      svgSrc:
        "http://research.gzsys.org.cn/perturbdb/data/publications/" +
        this.$route.query.datasetId +
        "/batchPlot/" +
        this.$route.query.gene +
        ".score.png",
      //basic infor
      gene: "",
      ensgId: "",
      genetype: "",
      alias: "",
      geneId: "",
      genetag: "",
      summary: "",
      fullname: "",
      localization: "",
      uniprot: "",
      //perturbatuon rate
      PR: "",
      // 是否能形成 PC
      isPC: false,
      pcLinks: "",
      pcplot: null,
      //pcplot:
      // "http://research.gzsys.org.cn/perturbdb/data/clusters/result_plot/" +
      // this.$route.query.pcID +
      // ".pdf",
      //帮助弹窗
      visibleInhibitor: false,
      visibleScore: false,
      visibleDE: false,
      //TCGA
      diffcancer: 0,
      //oncoPheno
      showOncoPheno: "No",
      // 弹窗
      modal: false,
      selectCancer: "",
      pvalue: 0,
      //加载
      spinning: false,
      indicator: <a-icon type="sync" style="font-size: 50px" spin />,
      //全表搜索
      tcgaLoading: true,
      filterName_detable: "",
      tempdata_detable: [],
      //分页
      getdata_detable: null, //必须要生成这个data
      loading_detable: false,
      tableData_detable: [],
      tablePage_detable: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0,
      },
    };
  },
  methods: {
    headerCellClickEvent({
      column,
      triggerResizable,
      triggerSort,
      triggerFilter,
    }) {
      // 如果触发了列的其他功能按钮
      console.log(column["field"]);
      if (
        column.sortable &&
        !(triggerResizable || triggerSort || triggerFilter)
      ) {
        this.tcgaLoading = true;
        if (column.order === "desc") {
          axios
            .get(
              "http://research.gzsys.org.cn/perturbdb/API/TCGA/search_diffMessage.php",
              {
                params: {
                  ensgId: this.ensgId,
                },
              }
            )
            .then((response) => {
              const convertedArray = [...response.data].sort(
                (a, b) => b.mk - a.mk
              );
              this.getdata_detable = convertedArray;
              this.$refs.xTable.clearSort();
              this.findList_detable(this.getdata_detable);
              this.tcgaLoading = false;
            });
        } else if (column.order === "asc") {
          this.$refs.xTable.sort(column.property, "desc");
          var jiangxu = this.getdata_detable.sort(
            (a, b) => b[column.field] - a[column.field]
          ); // 按照 num 属性降序排序
          this.getdata_detable = jiangxu;
          this.findList_detable(this.getdata_detable);
          this.tcgaLoading = false;
        } else {
          this.$refs.xTable.sort(column.property, "asc");
          //var field = column.field;
          var shengxu = this.getdata_detable.sort(
            (a, b) => a[column.field] - b[column.field]
          ); // 按照 num 属性降序排序
          this.getdata_detable = shengxu;
          this.findList_detable(this.getdata_detable);
          this.tcgaLoading = false;
        }
      }
    },
    formatAmount({ cellValue }) {
      return XEUtils.commafy(XEUtils.toNumber(cellValue));
    },
    rowStyle({ row }) {
      if (row.mk == 2) {
        return {
          backgroundColor: "#AA4643",
          color: "#ffffff",
        };
      } else if (row.mk === 1) {
        return {
          backgroundColor: "#4572a7",
          color: "#ffffff",
        };
      }
    },
    showPDF(value1, value2) {
      this.modal = true;
      this.selectCancer = value1;
      this.pvalue = Number.parseFloat(value2).toPrecision(4);
      console.log(value2);
    },
    changeData(value) {
      this.marker = value;
      this.getdata_detable = this.gsea[value];
      this.findList_detable(this.getdata_detable);
    },
    exportDataEvent() {
      if (this.tempdata_detable.length == 0) {
        const list = this.getdata_detable;
        this.$refs.xTable.exportData({
          filename: "Pan-cancer_DE_of_" + this.$route.query.gene,
          type: "txt",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      } else {
        const list = this.tempdata_detable;
        this.$refs.xTable.exportData({
          filename:
            this.filterName_detable +
            "_related_Pan-cancer_DE_of_" +
            this.$route.query.gene,
          type: "txt",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      }
    },
    handleOk() {
      this.modal = false;
    },
    handleCancel() {
      // 创建一个隐藏的 <a> 元素
      var link = document.createElement("a");
      link.style.display = "none";

      // 设置文件的下载链接

      link.href = this.url;

      link.setAttribute(
        "download",
        this.methods + "_" + this.url.split("/").pop()
      );

      // 将 <a> 元素添加到文档中
      document.body.appendChild(link);

      // 模拟点击事件
      link.click();

      // 清理
      document.body.removeChild(link);
    },
    findList_detable(data) {
      this.loading_detable = true;
      setTimeout(() => {
        const list = data;
        this.loading_detable = false;
        this.tablePage_detable.totalResult = list.length;
        this.tableData_detable = list.slice(
          (this.tablePage_detable.currentPage - 1) *
            this.tablePage_detable.pageSize,
          this.tablePage_detable.currentPage * this.tablePage_detable.pageSize
        );
      }, 300);
    },
    handlePageChange_table({ currentPage, pageSize }) {
      this.tablePage_detable.currentPage = currentPage;
      this.tablePage_detable.pageSize = pageSize;
      if (this.tempdata_detable.length == 0) {
        this.findList_detable(this.getdata_detable);
      } else {
        this.findList_detable(this.tempdata_detable);
      }
    },
    searchEvent_detable() {
      this.tablePage_detable.currentPage = 1;
      const filterName = XEUtils.toValueString(this.filterName_detable)
        .trim()
        .toLowerCase();
      if (filterName) {
        const filterRE = new RegExp(filterName, "gi");
        const searchProps = ["cancer"];
        const rest = this.getdata_detable.filter((item) =>
          searchProps.some(
            (key) =>
              XEUtils.toValueString(item[key])
                .toLowerCase()
                .indexOf(filterName) > -1
          )
        );
        this.tempdata_detable = rest.map((row) => {
          const item = Object.assign({}, row);
          searchProps.forEach((key) => {
            item[key] = XEUtils.toValueString(item[key]).replace(
              filterRE,
              (match) => `${match}`
            );
          });
          return item;
        });
        this.findList_detable(this.tempdata_detable);
      } else {
        this.tempdata_detable = [];
        this.findList_detable(this.getdata_detable);
      }
    },
    hideInhibitors() {
      this.visibleInhibitor = false;
    },
    hideScore() {
      this.visibleScore = false;
    },
    downloadRDS() {
      // 创建一个隐藏的 <a> 元素
      var link = document.createElement("a");

      link.style.display = "none";

      // 设置文件的下载链接
      link.href =
        "http://research.gzsys.org.cn/perturbdb/data/publications/" +
        this.$route.query.datasetId +
        "/split_rdata/" +
        this.$route.query.gene +
        ".rds";

      link.setAttribute("download", this.$route.query.gene + ".rds");

      // 将 <a> 元素添加到文档中
      document.body.appendChild(link);

      // 模拟点击事件
      link.click();

      // 清理
      document.body.removeChild(link);
    },
    changeHash(idname) {
      document.querySelector(idname).scrollIntoView({
        inline: "nearest",
        behavior: "smooth",
      });
    },
  },
};
</script>
<style scpoed>
.h1 {
  font-size: 40px;
  font-weight: bolder;
}
.guider {
  font-weight: bolder;
  font-size: 20px;
}
.pdf-content {
  overflow: hidden;
  height: 50px;
}
.my-sort .custom-sort {
  padding: 0 4px;
}
.my-sort .custom-sort.is-order {
  color: #409eff;
}
</style>
